import React, { Component } from 'react';
import styles from './styles.scss'
import {
  Table,
    TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'
import CSSModules from 'helpers/CSSModulesUtil'
import Section from '../ReportSection/index'

import { CUSTOMER_INPUTS } from 'containers/NvqualReport/constants'
import ReportHeader from '../ReportHeader'
import ReportHeader2 from '../ReportHeader2'
import ReportHeader3 from '../ReportHeader3'
import CollapsableOverlay from 'components/custom/CollapsableOverlay'
import cn from 'classnames'

class CustomerInputsTable extends Component {

    constructor(props) {
        super(props)
        this.state = {
            collapse: false
        }
    }

    toggle = () => {
        this.setState(prevState => ({
            collapse: !prevState.collapse
        }));
    }

    renderTable() {
        const { customerInputs, section, showComments } = this.props
        const table = CUSTOMER_INPUTS[section].map((x, idx) => {
            if (!customerInputs[x]) return
            return (
            <TableRow key={`customerRow${section}${idx}`}>
                <TableCell key={`customerDesc${section}${idx}`} className={styles.desc}>
                    <div>{customerInputs[x].description}</div>
                </TableCell>
                <TableCell key={`customerVal${section}${idx}`} className={styles.value}>
                    <div>{customerInputs[x].value}</div>
                </TableCell>
                {showComments && <TableCell key={`customerComm${section}${idx}`} className={styles.comment}>
                    <div>{customerInputs[x].comment}</div>
                </TableCell>}
            </TableRow>
        )}).filter(x => x != null)
        return table
    }

    renderHeader = () => {
        const { title, titleSize } = this.props
        switch (titleSize) {
            case 1:
                return <ReportHeader title={title} />
            case 2:
                return <ReportHeader2 title={title} />
            case 3:
                return <ReportHeader3 title={title} />
        }
    }

    render(){
        const { customerInputs, section, showComments, title, titleSize } = this.props
        const { collapse } = this.state
        if (!customerInputs) return

        if (Object.keys(customerInputs)
            .filter(x => CUSTOMER_INPUTS[section].includes(x)).length == 0)
             return
        
        const tooLong = Object.keys(customerInputs)
                .filter(x => CUSTOMER_INPUTS[section].includes(x)).length > 2

        const table = this.renderTable()
        const tableClass = !collapse && tooLong ? cn(styles.table, styles.tableNotCollapsed) : styles.table

        return(
            <Section>
            {this.renderHeader()}
            <div className={styles.tableContainer}>
            <Table selectable={false} className={tableClass}>
            <TableHead key={`customerHead${section}`}>
                <TableCell key={`customerDesc${section}`} className={styles.desc}>Description</TableCell>
                <TableCell key={`customerVal${section}`} className={styles.value}>Value</TableCell>
                {showComments && <TableCell key={`customerComm${section}`} className={styles.comment}>Comments</TableCell>}
            </TableHead>
            {collapse ? table : table.slice(0, 2)}
            </Table>
            {tooLong && <CollapsableOverlay collapse={collapse} toggleCollapseFunc={this.toggle} />}
            </div>
            </Section>
        );
    }
}

CustomerInputsTable.defaultProps = {
    titleSize: 2
};

const withStyles = CSSModules(styles);
export default withStyles(CustomerInputsTable);